export const CLIENT_ID = 'savills-web';

export const PREVIEW_MODE_ERROR = 'Action is not allowed in preview mode';
